<script>
import { Bar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

const toolTipsCallBack = {
  title(tooltipItem, data) {
    return data.prefix
      ? data.prefix[tooltipItem[0].index]
      : data.labels[tooltipItem[0].index];
  },
  label(tooltipItem, data) {
    const arrData = data.datasets[tooltipItem.datasetIndex];
    let element = arrData.label;
    let elementValue = arrData.data[tooltipItem.index];

    // Loop through all datasets to get the actual total of the index
    let total = 0;
    for (let i = 0; i < data.datasets.length; i++) {
      total += data.datasets[i].data[tooltipItem.index];
    }
    let elementValuePercentage = ((elementValue / total) * 100).toFixed(2);

    if (data.isTotal) {
      return [`Total: ${total}`, `${element}: ${elementValue}`];
    } else if (data.percentageData) {
      return [elementValue + ` (${elementValuePercentage}%)`];
    } else {
      return [`${element}: ${elementValue}`];
    }
  }
};

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: ["ticksConfig"],
  data() {
    const ticksConfig = this.ticksConfig;
    return {
      options: {
        tooltips: {
          callbacks: toolTipsCallBack,
          backgroundColor: "#FFF",
          titleFontColor: "#00072B",
          bodyFontColor: "#FF6458",
          displayColors: false
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              stacked: true,
              gridLines: {
                drawOnChartArea: false
              },
              barThickness: 50
            }
          ],
          yAxes: [
            {
              stacked: true,
              gridLines: {
                drawOnChartArea: false
              },
              ticks: ticksConfig?.yAxes || { beginAtZero: true }
            }
          ]
        },
        legend: {
          display: false
        },
        legendCallback: chart => {
          let legendsConfig = [];
          chart.data.datasets.map(item => {
            legendsConfig.push(
              `<li class="legend-bar-chart">
                <span class="icon-bar" style="background-color: ${item.backgroundColor}"></span>
                <span>${item.label}</span>
              </li>`
            );
          });
          return `<ul class="flex flex-wrap">${legendsConfig.join("")}</ul>`;
        }
      }
    };
  },
  mounted() {
    const app = this;
    this.addPlugin({
      beforeDraw: chart => {
        const legendConfig = chart.generateLegend();
        app.$emit("generate-legend-bar-chart", legendConfig);
      }
    });
    this.renderChart(this.chartData, this.options);
  }
};
</script>
<style lang="scss">
li.legend-bar-chart {
  display: flex;
  align-items: center;
  margin-right: 20px;

  .icon-bar {
    margin-right: 10px;
    width: 30px;
    height: 5px;
  }
}
</style>
